import { supabase } from '../supabase';

// 🔹 جلب معلومات المستخدم من Supabase
export const getUserProfile = async (userId) => {
  try {
    // جلب البيانات مباشرة من جدول users مع التركيز على الحقول المطلوبة
    const { data, error } = await supabase
      .from('users')
      .select('id, full_name, phone, address')
      .eq('id', userId)
      .single();

    if (error) {
      // إذا لم يتم العثور على البيانات، نقوم بإنشاء سجل جديد
      if (error.code === 'PGRST116') {
        const { data: newUser, error: createError } = await supabase
          .from('users')
          .insert([
            {
              id: userId,
              full_name: '',
              phone: '',
              address: ''
            }
          ])
          .select()
          .single();

        if (createError) throw createError;
        
        return {
          status: 'success',
          data: newUser
        };
      }
      throw error;
    }

    return {
      status: 'success',
      data
    };

  } catch (error) {
    console.error('Error fetching user profile:', error);
    return {
      status: 'error',
      message: 'حدث خطأ أثناء جلب بيانات المستخدم',
      error: error.message
    };
  }
};

// 🔹 تحديث بيانات المستخدم في Supabase
export const updateUserProfile = async (userId, updates) => {
  try {
    // التحقق من وجود المستخدم أولاً
    const { data: existingUser, error: checkError } = await supabase
      .from('users')
      .select('*')
      .eq('id', userId)
      .single();

    if (checkError) {
      if (checkError.code === 'PGRST116') {
        // إذا لم يتم العثور على المستخدم، نقوم بإنشائه
        const { data: newUser, error: createError } = await supabase
          .from('users')
          .insert([
            {
              id: userId,
              ...(updates.full_name && { full_name: updates.full_name }),
              ...(updates.phone && { phone: updates.phone }),
              ...(updates.new_password && { password: updates.new_password }),
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString()
            }
          ])
          .select()
          .single();

        if (createError) throw createError;
        return {
          status: 'success',
          message: 'تم إنشاء الملف الشخصي بنجاح',
          data: newUser
        };
      }
      throw checkError;
    }

    // إذا كان التحديث يتضمن تغيير كلمة المرور، نتحقق أولاً من كلمة المرور الحالية
    if (updates.current_password) {
      if (existingUser.password !== updates.current_password) {
        throw new Error('كلمة المرور الحالية غير صحيحة');
      }
    }

    // تحديث بيانات المستخدم
    const { data, error } = await supabase
      .from('users')
      .update({
        ...(updates.full_name && { full_name: updates.full_name }),
        ...(updates.phone && { phone: updates.phone }),
        ...(updates.new_password && { password: updates.new_password }),
        updated_at: new Date().toISOString()
      })
      .eq('id', userId)
      .select()
      .single();

    if (error) throw error;

    return {
      status: 'success',
      message: 'تم تحديث البيانات بنجاح',
      data
    };
  } catch (error) {
    console.error('Error updating user profile:', error);
    return {
      status: 'error',
      message: 'حدث خطأ أثناء تحديث البيانات'
    };
  }
};

// 🔹 جلب إحصائيات الطلبات الخاصة بالمستخدم

export const getUserStats = async (userPhone) => {
  try {
    if (!userPhone) throw new Error('رقم الهاتف مطلوب لحساب الإحصائيات');

    // 🧩 توحيد شكل الرقم (عشان ما يبقاش اختلاف بين +20 و 0)
    const normalizedPhone = String(userPhone)
      .replace(/\s+/g, '')     // يشيل المسافات
      .replace(/^(\+20)/, '0') // لو الرقم بيبدأ بـ +20 يخليه 0
      .trim();

    // 🔍 اختبار مباشر في الكونسول
    console.log('📞 البحث بالرقم:', normalizedPhone);

    // جلب جميع الطلبات لهذا الرقم (بدون فلترة الحالة)
    const { data, error } = await supabase
      .from('orders')
      .select('*')
      .eq('customer_phone', normalizedPhone);
      
    if (error) throw error;

    // طباعة كل الطلبات للتحقق
    console.log('📱 البحث عن طلبات للرقم:', normalizedPhone);
    console.log('📦 جميع الطلبات لهذا الرقم:', data);
    if (data && data.length > 0) {
      console.log('حالات الطلبات الموجودة:', data.map(order => ({
        status: order.status,
        phone: order.customer_phone
      })));
    }
    
    // حساب إجمالي عدد الطلبات لهذا الرقم
    const totalOrders = data?.length || 0;
    console.log('📊 إجمالي عدد الطلبات:', totalOrders);
    
    // حساب الطلبات المكتملة وغير المستخدمة للنقاط فقط (للنقاط)
    const deliveredAndUnusedCount = data?.filter(order => 
      order.status === 'تم التوصيل' && 
      order.points_status === 'unused'
    ).length || 0;
    console.log('✅ عدد الطلبات المتاحة للنقاط:', deliveredAndUnusedCount);

    const pointsPerOrder = 10; // نقاط لكل طلب مكتمل
    const totalPoints = deliveredAndUnusedCount * pointsPerOrder;

    return {
      status: 'success',
      data: {
        orders: totalOrders, // العدد الإجمالي للطلبات
        points: totalPoints, // النقاط المتاحة فقط
        unusedOrders: deliveredAndUnusedCount // عدد الطلبات التي يمكن استخدامها للنقاط
      }
    };
  } catch (error) {
    console.error('❌ Error fetching user stats:', error);
    return {
      status: 'error',
      message: 'حدث خطأ أثناء جلب إحصائيات المستخدم',
      error: error.message
    };
  }
};

// 🔹 جلب جميع الطلبات الخاصة بالمستخدم


// 🔹 تقديم طلب سحب النقاط
export const submitWithdrawalRequest = async (withdrawalData) => {
  try {
    // 1. جلب الطلبات غير المستخدمة مرتبة حسب التاريخ تصاعدياً
    const { data: unusedOrders, error: ordersError } = await supabase
      .from('orders')
      .select('*')
      .eq('customer_phone', withdrawalData.customer_phone)
      .eq('status', 'تم التوصيل')
      .eq('points_status', 'unused')
      .order('created_at', { ascending: true });

    if (ordersError) throw ordersError;

    // 2. حساب عدد الطلبات المطلوبة للنقاط المحددة
    const pointsPerOrder = 10; // نقاط لكل طلب
    const ordersNeeded = Math.ceil(withdrawalData.points_amount / pointsPerOrder);
    
    // التحقق من أن عدد النقاط يساوي عدد الطلبات المتاحة × 10
    const availablePoints = unusedOrders.length * pointsPerOrder;
    if (withdrawalData.points_amount > availablePoints) {
      throw new Error(`عدد النقاط المتاحة ${availablePoints} نقطة فقط`);
    }

    // 3. التحقق من وجود عدد كافٍ من الطلبات
    if (unusedOrders.length < ordersNeeded) {
      throw new Error('لا يوجد عدد كافٍ من الطلبات المتاحة للنقاط');
    }

    // 4. تحديث حالة النقاط للطلبات المطلوبة
    const ordersToUpdate = unusedOrders.slice(0, ordersNeeded);
    const { error: updateError } = await supabase
      .from('orders')
      .update({ points_status: 'pending' })
      .in('id', ordersToUpdate.map(order => order.id));

    if (updateError) throw updateError;

    // 5. إنشاء طلب السحب
    const { data: withdrawalRecord, error: withdrawalError } = await supabase
      .from('withdraw_point_to_money')
      .insert([
        {
          customer_phone: withdrawalData.customer_phone,
          full_name: withdrawalData.full_name,
          withdraw_phone_number: withdrawalData.withdraw_phone_number,
          pay_method_type: withdrawalData.pay_method_type,
          points_amount: withdrawalData.points_amount,
          created_at: new Date().toISOString()
        }
      ])
      .select()
      .single();

    if (withdrawalError) throw withdrawalError;

    return {
      status: 'success',
      message: 'تم تقديم طلب السحب بنجاح',
      data: withdrawalRecord
    };
  } catch (error) {
    console.error('Error submitting withdrawal request:', error);
    return {
      status: 'error',
      message: error.message || 'حدث خطأ أثناء تقديم طلب السحب'
    };
  }
};

// 🔹 إضافة طلب جديد
export const addUserOrder = async (userId, order) => {
  try {
    const { data, error } = await supabase
      .from('orders')
      .insert([
        {
          user_id: userId,
          customer_name: order.customer_name,
          customer_phone: order.customer_phone,
          pickup_address: order.pickup_address,
          delivery_address: order.delivery_address,
          notes: order.notes,
          status: 'قيد الانتظار'
        }
      ])
      .select()
      .single();

    if (error) throw error;

    return {
      status: 'success',
      message: 'تم إضافة الطلب بنجاح',
      data
    };
  } catch (error) {
    console.error('Error adding user order:', error);
    return {
      status: 'error',
      message: 'حدث خطأ أثناء إضافة الطلب'
    };
  }
};
